import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <small className="footer">
      <a
        href="https://github.com/zanibao/my-weather-react"
        target="_blank"
        rel="noopener noreferrer"
      >
        Open source code {""}
      </a>
      by {""}{" "}
      <a
        href="https://www.linkedin.com/in/anazanibao/?locale=en_US"
        target="_blank"
        rel="noopener noreferrer"
      >
        Ana Paula Zanibão
      </a>
    </small>
  );
}
